import React from 'react';
import PropTypes from 'prop-types';
import { isEmptyString } from 'utils/text';
import css from './HelpResources.scss';
import Icon from 'SF/MaterialIcon';
import { pressedEnterOrSpace } from 'utils/accessibility';
import copy from 'clipboard-copy';

/**
 * @returns {JSX.Element|null} the help desk email, if present
 */
function HelpEmail({ email }) {
    // Copies the support email into the clipboard
    const copyEmailLink = async () => {
        try {
            await copy(email);
        } catch (e) {
            /* istanbul ignore next */
            console.warn(e);
        }
    };

    if (isEmptyString(email)) return null;
    return (
        <div className={css['helpdesk-item']}>
            <div className={css['helpdesk-icon']}>
                <Icon icon="mail" aria-hidden="true" />
            </div>
            <div className={css['helpdesk-element']}>
                <a href="#"
                   aria-label="Click link to copy contents to clipboard"
                   className={css['links']}
                   onClick={() => copyEmailLink(email)}
                   onKeyDown={(e) => {
                       if (pressedEnterOrSpace(e)) {
                           // noinspection JSIgnoredPromiseFromCall
                           copyEmailLink(email);
                           e.preventDefault();
                       }}}>
                    {email}
                </a>
                <span>Click email to copy/paste</span>
            </div>
        </div>
    )
}

HelpEmail.propTypes = {
    email: PropTypes.string
}

export default HelpEmail;
